import { render, staticRenderFns } from "./EditMedicine.vue?vue&type=template&id=71de50c4&scoped=true"
import script from "./EditMedicine.vue?vue&type=script&lang=js"
export * from "./EditMedicine.vue?vue&type=script&lang=js"
import style0 from "./EditMedicine.vue?vue&type=style&index=0&id=71de50c4&prod&lang=scss&scoped=true"
import style1 from "./EditMedicine.vue?vue&type=style&index=1&id=71de50c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de50c4",
  null
  
)

export default component.exports